<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <v-col cols="12" sm="4" md="2">
                        <v-text-field label="Accidentes - Año" dense v-model="periodoanterior">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-btn color="success" @click.stop="generateGroupedData(periodoanterior)">Buscar</v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-btn color="red" to="/AccidentesNuevo">Nuevo Accidente</v-btn>
                </v-card-title>
                <!-- <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar" class="elevation-1"
            :items-per-page="100" hide-default-footer :loading="loadtable" loading-text="Cargando... Espere por favor"
            no-data-text="No hay datos disponibles">
          </v-data-table>   
           -->
                <v-data-table :headers="headers" :items="tableData" group-by="area" item-value="id" class="elevation-1"
                    dense hide-default-footer :items-per-page="500">
                    <template v-slot:group.header="{ items }">
                        <!-- <tr @click="toggleGroup"> -->
                        <tr>
                            <td colspan="headers.length" class="group-header">
                                <!-- <v-icon>{{ isGroupOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon> -->
                                <strong>{{ items[0].area }} </strong>
                                <!-- <strong>{{ item.value }}</strong> -->
                            </td>
                        </tr>
                    </template>

                    <template v-slot:item="{ item }">
                        <tr v-if="item.isSectorHeader" class="sector-header">
                            <td colspan="6"><strong>{{ item.sector }}</strong></td>
                        </tr>
                        <tr v-else>
                            <!-- <td></td> -->
                            <td></td>
                            <td>{{ item.nombre }}</td>
                            <td>{{ item.fecha }}</td>
                            <td>{{ item.accidente }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

        </v-app>
    </div>
</template>
<style scoped>
.group-header {
    background-color: #ddd;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.sector-header {
    background-color: #eee;
    font-weight: bold;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
// import VerListado from "../Posventa/Listadoestadistica.vue";
// import VerIndicador from "../Posventa/Diasindicador.vue";
export default {
    // components: { VerListado, VerIndicador },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        afecta: "",
        showListado: false,
        showIndicador: false,
        periodo: moment().format("YYYY"),
        periodoanterior: "",
        headers: [
            { text: "Área", value: "area", align: "start" },
            { text: "Sector", value: "sector", align: "start" },
            { text: "Accidentado", value: "nombre", align: "start" },
            { text: "Fecha", value: "fecha", align: "start" },
            { text: "Descripción del Accidente", value: "accidente", align: "start" },
        ],
        tableData: [],
        listado: [],
        loadtable: false,

    }),
    computed: {
        show: {
            get() {
                //this.cargarListados();
                this.generateGroupedData(this.periodo);
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },

    },

    methods: {

        generateGroupedData(periodo) {

            this.vaciarModels();

            let self = this;
            let rawData = [];
            axios
                .get("/Icssa/ListadoAccidentes?", {
                    params: {
                        periodo: periodo
                    },
                })
                .then((response) => {
                    rawData = response.data;
                    console.log("d", rawData)
                    let groupedData = [];
                    let sectorTracker = new Set();

                    rawData.forEach((item) => {
                        const sectorKey = `${item.area}-${item.sector}`;

                        if (!sectorTracker.has(sectorKey)) {
                            groupedData.push({ area: item.area, sector: item.sector, isSectorHeader: true });
                            sectorTracker.add(sectorKey);
                        }

                        groupedData.push({ ...item, isSectorHeader: false });
                    });
                    console.log("DATOS", groupedData)
                    this.tableData = groupedData;
                })
                .catch((error) => {
                    rawData = [];
                    console.log(error);
                });

            // const rawData = [
            //     { area: "Planta 1", sector: "Producción", accidentado: "Juan", fecha: "2024-01-10", accidente: "Corte en mano" },
            //     { area: "Planta 1", sector: "Producción", accidentado: "Pedro", fecha: "2024-01-11", accidente: "Golpe en la pierna" },
            //     { area: "Planta 1", sector: "Mantenimiento", accidentado: "Luis", fecha: "2024-01-12", accidente: "Quemadura leve" },
            //     { area: "Planta 2", sector: "Almacén", accidentado: "Carlos", fecha: "2024-01-13", accidente: "Fractura de pie" },
            //     { area: "Planta 2", sector: "Almacén", accidentado: "Andrés", fecha: "2024-01-14", accidente: "Contusión en la cabeza" },
            // ];


        },

        verListado(item, afecta) {
            //  this.editedIndex = this.listadoP.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.afecta = afecta;
            this.showListado = true;
        },
        indicador() {
            this.showIndicador = true;
        },
        vaciarModels() {
            this.tableData = [];
        },
        refrescar() {
            //  this.cargarListados();
            this.showEjecucion = false;
        },
    },
};
</script>